import { Dialog, DialogPanel } from '@headlessui/react'
import React, { useState } from 'react'
import useScrollToTop from '../components/useScrollToTop.js';
import moment from 'moment';


const NDRTableHistory = ({ open, setOpen, selectedRowData }) => {
    useScrollToTop();


    return (
        <div>
            {open &&
                <Dialog open={open} onClose={() => { }} className="relative z-50">
                    <div
                        transition
                        className="fixed inset-0 bg-black bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
                    />

                    <div className="fixed inset-0 z-50 w-screen overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center p-4 sm:items-center sm:p-0">
                            <DialogPanel
                                transition
                                className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95 lg:max-w-xl xl:max-w-2xl 2xl:max-w-7xl"
                            >
                                <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                                    <div className="sm:flex sm:items-start">
                                        <div className="mt-2 w-full">
                                            <h1 className="font-bold text-lg text-gray-700 mb-6">
                                                All Delivery Attempts Tracked
                                            </h1>
                                            <div className="overflow-x-auto rounded-md">
                                                <table className="w-full text-sm border-collapse rounded-md">
                                                    <thead>
                                                        <tr className="bg-gray-200 text-gray-600 uppercase text-xs tracking-wider">
                                                            <th className="p-3 border">Date</th>
                                                            <th className="p-3 border">Action</th>
                                                            <th className="p-3 border">Remarks</th>
                                                            <th className="p-3 border">Attempt #</th>
                                                            <th className="p-3 border">By</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {selectedRowData?.map((entry, index) => (
                                                            <tr
                                                                key={index}
                                                                className="border-b bg-white "
                                                            >
                                                                <td className="p-3 border-b">
                                                                    {moment(entry?.event_date).format("DD/MM/YYYY HH:mm")}
                                                                </td>
                                                                <td className="p-3 border-b text-gray-500 font-medium">NDR Raised</td>
                                                                <td className="p-3 border-b text-gray-700">{entry?.courier_remarks}</td>
                                                                <td className="p-3 border-b text-center font-semibold">{entry?.total_attempts}</td>
                                                                <td className="p-3 border-b text-gray-700">{entry?.By}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="bg-slate-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                                    <button
                                        type="button"
                                        data-autofocus
                                        onClick={() => setOpen(false)}
                                        className="mt-3 w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-slate-50 sm:mt-0"
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </DialogPanel>
                        </div>
                    </div>
                </Dialog>
            }
        </div>
    )
}

export default NDRTableHistory
